var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no_data",staticStyle:{"margin-top":"50px"}},[_c('img',{attrs:{"src":require("@image/me/money_nonedata.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }